import OpportunitieByChannel from '../opportunitiesByChannel/components/OpportunitieByChannel';

export const OppsByChannelSubBranch = (_) => {
  return <OpportunitieByChannel subBranchDashboard={true} />;
};
